import {
  GoogleAnalytics as NextGoogleAnalytics,
  GoogleTagManager as NextGoogleTagManager,
} from '@next/third-parties/google';

type GoogleTrackingMode = 'none' | 'ga4' | 'gtm';

interface TrackingScriptsProps {
  googleTrackingMode?: GoogleTrackingMode | null;
  googleAnalyticsId: string | null;
  googleTagManagerId: string | null;
  googleTagManagerEnabled: boolean;
}

function hasValidGaId(measurementId: string | null): measurementId is string {
  return !!measurementId && measurementId.startsWith('G-');
}

function hasValidGtmId(containerId: string | null): containerId is string {
  return !!containerId && containerId.startsWith('GTM-');
}

export function TrackingScripts({
  googleTrackingMode,
  googleAnalyticsId,
  googleTagManagerId,
  googleTagManagerEnabled,
}: TrackingScriptsProps) {
  const hasGa = hasValidGaId(googleAnalyticsId);
  const hasGtm = googleTagManagerEnabled && hasValidGtmId(googleTagManagerId);
  const effectiveMode: GoogleTrackingMode =
    googleTrackingMode === 'ga4' || googleTrackingMode === 'gtm' || googleTrackingMode === 'none'
      ? googleTrackingMode
      : hasGtm
        ? 'gtm'
        : hasGa
          ? 'ga4'
          : 'none';

  if (effectiveMode === 'none') {
    return null;
  }

  return (
    <>
      {effectiveMode === 'ga4' && hasGa ? <NextGoogleAnalytics gaId={googleAnalyticsId} /> : null}

      {effectiveMode === 'gtm' && hasGtm ? (
        <NextGoogleTagManager gtmId={googleTagManagerId} />
      ) : null}
    </>
  );
}
